import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Modal
}                       from 'react-bootstrap';
import { connect }    from 'react-redux';
import { createHashHistory } from 'history';
import { withRouter, Link } from "react-router-dom";
import { subscribeUser } from '../../../redux/actions/frontActions';
import './Footer.css'
import moment from "moment";
import Cookies from "universal-cookie";
import ReactHtmlParser from "react-html-parser";
const cookies = new Cookies();
const history = createHashHistory();
class Footer extends Component {

  constructor(props, context){
    super(props, context);
    this.state = {
      themeData: {},
      footerBgStyles: {},
      footerTextStyles: {},
      email: '',
      facebookPage: '',
      twitterPage: '',
      youtube_link: '', 
      insta_link: '',
      showSubscriptionFrom: false,
      subscriptionResponse: false,
      siteName: '',
      hover: false,
    };

    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.handleShowSubscriptionFrom = this.handleShowSubscriptionFrom.bind(this);
    this.handleCloseSubscriptionFrom = this.handleCloseSubscriptionFrom.bind(this);
    this.handleHideSubscriptionFrom = this.handleHideSubscriptionFrom.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleCloseSubscriptionFrom() {
    localStorage.setItem('disableSubscriptionPopup', true);
    this.setState({ showSubscriptionFrom: false });
  }

  handleHideSubscriptionFrom() {
    localStorage.setItem('disableSubscriptionPopup', true);
    // this.setState({ showSubscriptionFrom: true });
  }


  handleShowSubscriptionFrom() {
    this.setState({ showSubscriptionFrom: true });
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let checkDealID = (cookies.get("affiliateID")) ? cookies.get("affiliateID") : '';
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData && siteData.default_city){
       this.setState({subscriptionResponse: true});
       const data = {
          city: [siteData.default_city],
          email: this.state.email,
          frequency: 'DAILY',
          geo_subscriber: 'yes',
          affiliateID: (cookies.get("affiliateID")) ? checkDealID.affiliateID : '',
        }

        this.props.subscribeUser(data);
    }else{
      alert("Please select city.");
    }
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    if(siteData){
      this.setState({twitterPage: siteData.twitterPage,facebookPage: siteData.facebookPage, siteName: siteData.siteName, youtube_link: siteData.youtube_link, insta_link: siteData.insta_link});
      if(siteData.popup_subscrbe == 'enable' && this.props.match.path == '/' && disableSubscriptionPopup == false){
        this.setState({ showSubscriptionFrom: true });
      }
    }

    if(this.props.themeData){
      this.setState({
        themeData: this.props.themeData
      });

      if(this.props.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(this.props.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : this.props.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData){
      this.setState({
        themeData: nextProps.themeData
      });

      if(nextProps.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: nextProps.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(nextProps.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': nextProps.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': nextProps.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : nextProps.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }


    if(this.props.subscribeStatus != nextProps.subscribeStatus && nextProps.subscribeStatus){
      if(nextProps.subscribeStatus.response =='success'){
        localStorage.setItem('disableSubscriptionPopup', true);
        this.setState({ showSubscriptionFrom: false });
      }
      alert(nextProps.subscribeStatus.message);
    }
  }

  render() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    return (
      <div>
        <div className="subscriber" style={this.state.menuBgStyles}>
          <div className="container">
            <Row>
              <Col lg={12} md={12} sm={12} xs={12} className="text-center">
              <Form inline onSubmit={this.handleSubmit}>
                <FormGroup controlId="formInlineEmail">
                  <ControlLabel>Subscribe to our mailing list: </ControlLabel>{' '}
                  <FormControl type="email" name="email" placeholder="john.doe@example.com" required onChange={this.handleChange} />
                </FormGroup>
                <FormGroup controlId="button" className="subscription">
                <Button 
                  type="submit" 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "subs") ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {"subs"}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff} 
                  className="cursor"
                >Subscribe</Button>
                </FormGroup>
              </Form>
              </Col>
            </Row>
          </div>
        </div>
        <Modal show={this.state.showSubscriptionFrom} onHide={this.handleHideSubscriptionFrom}  backdrop="static" >
          <Modal.Header closeButton onClick={this.handleCloseSubscriptionFrom}>
            <Modal.Title>Subscribe to our mailing list</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form inline onSubmit={this.handleSubmit}>
              <FormGroup controlId="formInlineEmail">
                <ControlLabel>{' '}</ControlLabel>{' '}
                <FormControl type="email" name="email" placeholder="john.doe@example.com" required onChange={this.handleChange} />
              </FormGroup>
              <FormGroup controlId="button">
              <Button 
                type="submit" 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'cribe') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {'cribe'}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                >Subscribe</Button>
              </FormGroup>
            </Form>
          </Modal.Body>
          {/*<Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSubscriptionFrom}>
              Close
            </Button>
            <Button variant="primary" onClick={this.handleCloseSubscriptionFrom}>
              Save Changes
            </Button>
          </Modal.Footer>*/}
        </Modal>
        {(siteData && siteData.dynamic_footer == 1 && siteData.footer_content.dynamic_footer_status == 'enable' && siteData.footer_content.footer_content !== '') ?
        ReactHtmlParser(siteData.footer_content.footer_content)
        :
        <div className="footer" style={this.state.footerBgStyles}>
          <div className="container">
            <Row>
              <Col lg={3} md={3} sm={12} xs={12}>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/aboutUs`)}>
                    About Us
                  </Button>
                </div>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/contactUs`)}>
                    Contact Us
                  </Button>
                </div>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/become-partner`)}>
                    Become A Partner
                  </Button>
                </div>
                
                
              </Col>
              <Col lg={3} md={3} sm={12} xs={12}>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/subscription-manager`)}>
                   Email Subscriptions
                  </Button>
                </div>

                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/faq`)}>
                   FAQs
                  </Button>
                </div>
               
                 {localStorage.getItem("user") ? (
                    <div>
                      {(localStorage.getItem('userTypeName') === 'customer') ?
                      <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/my-account`)}>
                        Dashboard
                      </Button>
                      :
                      <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/dashboard`)}>
                        Dashboard
                      </Button>
                      }
                    </div>
                  ) : (
                    <div>
                    <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/login`)}>
                       Login
                    </Button>
                  </div>
                  )}
                  
              </Col>
              <Col lg={3} md={3} sm={12} xs={12}>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/termsAndCondition`)}>
                    Terms And Conditions
                  </Button>
                </div>
                <div>
                  <Button bsStyle="link" style={this.state.footerTextStyles} onClick={() => history.push(`/privacyPolicy`)}>
                    Privacy Policy
                  </Button>
                </div>
              </Col>
              <Col lg={3} md={3} sm={12} xs={12}>
                {(this.state.facebookPage || this.state.twitterPage || this.state.insta_link || this.state.youtube_link) &&
                <h4>Connect with us</h4>
                }
                <div className="footer-social-icons">
                    {(this.state.facebookPage) &&
                    <a href={this.state.facebookPage} style={this.state.footer_social_link_color} target="_blank" className="facebook">
                      <i className="fa fa-facebook-official" />
                    </a>
                    }
                    {(this.state.twitterPage) &&
                    <a href={this.state.twitterPage} style={this.state.footer_social_link_color} target="_blank" className="twitter">
                      <i className="fa fa-twitter" />
                    </a>
                    }
                    {(this.state.insta_link) &&
                    <a href={this.state.insta_link} style={this.state.footer_social_link_color} target="_blank" className="twitter">
                      <i className="fa fa-instagram" />
                    </a>
                    }
                    {(this.state.youtube_link) &&
                    <a href={this.state.youtube_link} style={this.state.footer_social_link_color} target="_blank" className="twitter">
                      <i className="fa fa-youtube-play" />
                    </a>
                    }
                </div>
              </Col>
              <Col md={12} xs={12}>
                <hr/>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="text-center" style={this.state.footerTextStyles}>
                    Copyright {moment().format("YYYY")} {this.state.siteName} 
              </Col>
            </Row>
          </div>
        </div>
        }

      </div>
    );
  }
}

Footer.propTypes = {
 subscribeUser: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  subscribeStatus: state.frontReducer.subscribeStatus,
  error: state.frontReducer.error,
})

export default withRouter(connect(mapStateToProps,{subscribeUser})(Footer));



// WEBPACK FOOTER //
// ./src/app/views/frontend/Footer/Footer.js